import UnknownResult from './views/unknown'
import SummaryResult from './views/summaryv2'
import NextResult from './views/next'
import TDNextResult from './views/tdnext'
import WiremapResult from './views/wiremap'
import FiberResult from './views/fiber'
import TabularSubtest from './views/tabularsubtests'
import ResistanceUnbalancedSubTests from './views/resistanceunbalancesubtests'
import MobileTestSummary from "./views/summaryv2/mobileTestSummary";

const ResultMap = {
  'Summary': SummaryResult,
  'MobileTestSummary': MobileTestSummary,
  'NEXT': NextResult,
  'ATTEN': NextResult,
  'ACRN': NextResult,
  'RTNLOSS': NextResult,
  'ACRF': NextResult,
  'PSACRF': NextResult,
  'PSNEXT': NextResult,
  'PSACRN': NextResult,
  'Wiremap': WiremapResult,
  'TDNEXT': TDNextResult,
  'TDRTNLOSS': TDNextResult,
  'Fiber': FiberResult,
  'FiberCable': FiberResult,
  'Length': TabularSubtest,
  'DelaySkew': TabularSubtest,
  'PropagationDelay': TabularSubtest,
  'Resistance': TabularSubtest,
  'HeadRoom': TabularSubtest,
  'Capacitance': TabularSubtest,
  'Impedance': TabularSubtest,
  'TCL': NextResult,
  'ELTCTL': NextResult,
  // 'CMRL': NextResult,
  // 'CDNEXT': NextResult,
  'ResistanceUnBalancedPair': ResistanceUnbalancedSubTests,
  'unknown': UnknownResult
}

const GetResultView = (result) => {
  return (ResultMap.hasOwnProperty(result))
    ? ResultMap[result]
    : ResultMap['unknown']
}

export default GetResultView



// WEBPACK FOOTER //
// ./src/components/common/results/getResult.js